<template>
  <router-link to="/" class="app-bar-home-link">
    <img
      src="@/assets/logo_capital_partners_alt.svg"
      alt="Loyall Capital Partners"
      height="36"
    />
  </router-link>
</template>

<script>
export default {
  name: 'AppBarHomeLink',
};
</script>

<style lang="scss" scoped>
  .app-bar-home-link {
    height: 100%;
    padding: 0 12px;

    color: inherit;
    text-decoration: none;

    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color .2s ease;

    &:hover {
      background-color: rgba(0, 0, 0, .1);
    }
  }
</style>
